"use client";

import { OrgSwitcher } from "@/components/OrgSwitcher/OrgSwitcher";

interface UserDropdownProps {
  isCollapsed: boolean;
  showSettingsAndHelp?: boolean;
}

export const UserDropdown = ({ isCollapsed, showSettingsAndHelp }: UserDropdownProps) => {
  return <OrgSwitcher isCollapsed={isCollapsed} showSettingsAndHelp={showSettingsAndHelp} />;
};
